import axios from 'axios';
import { errorInteractions } from '../../analytics';

const handleError = (errorMsg, pageSection) => {
  const errorObject = {
    type: 'catastrophic',
    displayType: 'inline',
    pageSection,
    message: errorMsg,
  };
  errorInteractions({
    errorObject,
    primaryCategory: 'error',
    eventName: 'post page error',
  });
  return null;
};

const postCabinetSellerCache = async (url, navParams, errorMsg, pageSection) => {
  try {
    const response = await axios.post(url, navParams);
    if (response?.status === 200) {
      return response.data;
    }
    throw new Error(errorMsg);
  } catch {
    return handleError(errorMsg, pageSection);
  }
};

export const tryGetCabinetSellerCache = async (host, choiceId, navParams, cacheType) => {
  const errorMsg = 'Get Cabinet-Seller Cache: Request Failed';
  const url = `${host}/api/modulardesigner/cache/sellerBychoice/${choiceId}?cacheType=${cacheType ?? 1}`;
  return postCabinetSellerCache(url, navParams, errorMsg, 'Get CabinetSeller-Cache');
};

export const tryGetCabinetSellerCacheWithCollection = async (host, choiceId, navParams, omsId, cacheType) => {
  const errorMsg = 'Get Cabinet-Seller Cache With Collection: Request Failed';
  const url = `${host}/api/modulardesigner/cache/sellerBychoice/${choiceId}/${omsId}?cacheType=${cacheType ?? 1}`;
  return postCabinetSellerCache(url, navParams, errorMsg, 'Get CabinetSeller-Cache-WithCollection');
};